const PreferenceType = {
	communityApp: 'communityApp',
	landingPage: 'LandingPage',
	prerelease: 'PreRelease',
	reader: 'reader',
};

export default PreferenceType;
